/**
 * Settings Page Translations
 */

import { Translations } from '../shared/i18n';

export const settingsTranslations: Translations = {
    tr: {
        settingsTitle: 'Ayarlar',
        securityTab: 'Güvenlik',

        // Set password (SSO users without password)
        setPasswordSection: 'Şifre Belirle',
        setPasswordDesc: 'SSO ile giriş yaptınız. İsterseniz bir şifre de belirleyebilirsiniz.',
        newPassword: 'Yeni Şifre',
        confirmPassword: 'Şifre Tekrar',
        setPasswordButton: 'Şifre Belirle',

        // Change password (users with existing password)
        changePasswordSection: 'Şifre Değiştir',
        changePasswordDesc: 'Mevcut şifrenizi değiştirin.',
        currentPassword: 'Mevcut Şifre',
        changePasswordButton: 'Şifreyi Değiştir',

        // Validation & feedback
        passwordMinLength: 'Şifre en az 8 karakter olmalıdır',
        passwordMismatch: 'Şifreler eşleşmiyor',
        passwordSetSuccess: 'Şifre başarıyla belirlendi',
        passwordChangeSuccess: 'Şifre başarıyla değiştirildi',
        passwordError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    en: {
        settingsTitle: 'Settings',
        securityTab: 'Security',

        setPasswordSection: 'Set Password',
        setPasswordDesc: 'You signed in with SSO. You can optionally set a password for direct login.',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        setPasswordButton: 'Set Password',

        changePasswordSection: 'Change Password',
        changePasswordDesc: 'Change your current password.',
        currentPassword: 'Current Password',
        changePasswordButton: 'Change Password',

        passwordMinLength: 'Password must be at least 8 characters',
        passwordMismatch: 'Passwords do not match',
        passwordSetSuccess: 'Password set successfully',
        passwordChangeSuccess: 'Password changed successfully',
        passwordError: 'An error occurred. Please try again.',
    },
};
